import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IListState, PaginationType } from '@typings/requestPayloads'
import { STATUS } from '@features/General'

export interface IListEventCampaignPayload {
    pagination?: PaginationType
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const eventCampaignList = createSlice({
    name: 'campaigns/event-campaign-list',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IListEventCampaignPayload>) {
            state.status = STATUS.RUNNING
        },
        onAddItemToList(state, action) {
            const newData = [...state.data]
            newData.push(action.payload)
            state.data = newData
        },
        onEditItemInList(state, action) {
            const newData = [...state.data]
            const editedItem = newData.find(item => item._id === action.payload._id)
            if (editedItem) {
                for (const key in action.payload) {
                    editedItem[key] = action.payload[key]
                }
            }
            state.data = newData
        },
        onDeleteItemFromList(state, action) {
            const newData = [...state.data].filter(item => item._id !== action.payload)
            state.data = newData
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
            state.pagination = {
                ...state.pagination,
                skip: action.payload.skip,
                total: action.payload.total
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        },
        onChangeStatus(state, action) {
            const newData = [...state.data]
            const campaign = newData.find(item => item._id === action.payload.campaignId)
            campaign.status = action.payload.status
            state.data = newData
        }
    }
})

export const eventCampaignListActions = eventCampaignList.actions
export default eventCampaignList.reducer
